import styled, { keyframes } from 'styled-components'
import { black, border2, darkOrange, orange, textMuted, warmTint, white } from '@/theme/colors'
import { Button } from '../../pages/Itinerary/AddEventModal/FormComponents.styles'

/**
 * The shared form CTA minus its `transition: all` — the survey CTA flips
 * between disabled/enabled as options toggle, and animating that read as a
 * distracting fade here. Other modals keep the shared behavior.
 */
export const SurveyCta = styled(Button)`
	transition: none;
`

const optionIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(8px);
	}
	to {
		opacity: 1;
		transform: none;
	}
`

export const OptionList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 4px 0;
`

/** One survey answer card: icon chip + text, fading up with a light stagger. */
export const OptionButton = styled.button<{ $selected: boolean; $index: number }>`
	display: flex;
	align-items: center;
	gap: 14px;
	width: 100%;
	padding: 14px 16px;
	border-radius: 12px;
	border: 1px solid ${({ $selected }) => ($selected ? orange : border2)};
	background-color: ${({ $selected }) => ($selected ? warmTint : white)};
	cursor: pointer;
	text-align: left;
	animation: ${optionIn} 0.28s ease-out both;
	animation-delay: ${({ $index }) => $index * 45}ms;
	transition:
		border-color 0.15s ease,
		background-color 0.15s ease,
		box-shadow 0.15s ease;

	&:hover {
		border-color: ${orange};
		box-shadow: 0 3px 10px rgba(209, 95, 42, 0.12);
	}

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`

export const OptionIconChip = styled.span<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	flex-shrink: 0;
	border-radius: 12px;
	background: ${({ $selected }) => ($selected ? orange : warmTint)};
	color: ${({ $selected }) => ($selected ? white : darkOrange)};
	transition:
		background-color 0.15s ease,
		color 0.15s ease;
`

export const OptionTexts = styled.span`
	display: flex;
	flex-direction: column;
	gap: 3px;
	min-width: 0;
`

export const OptionTitle = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: ${black};
`

export const OptionDescription = styled.span`
	font-size: 13.5px;
	color: ${textMuted};
`
